import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { isDocSlug } from './registry';
import { resolvePreferredDocsLang } from './docsLang';
import { DocNotFound } from './DocNotFound';

export function DocCanonicalRedirect() {
    const { slug } = useParams<{ slug: string }>();
    const navigate = useNavigate();

    useEffect(() => {
        if (!slug || !isDocSlug(slug)) return;
        const lang = resolvePreferredDocsLang();
        const hash = typeof window !== 'undefined' ? window.location.hash : '';
        navigate(`/docs/${lang}/${slug}${hash}`, { replace: true });
    }, [slug, navigate]);

    if (!slug || !isDocSlug(slug)) {
        return <DocNotFound />;
    }

    return (
        <div className="doc-loading" style={{ padding: '2rem' }}>
            正在跳转…
        </div>
    );
}
